import React from "react"
import { css } from "@emotion/react"
import Layout from "../components/layout"
import Seo from "../components/seo"

const Parts = () => {
  return (
    <section className="imgtext">
      <div className="imgtext-container w-container">
        <div className="text">
          <h2>日常のツールたち</h2>
          <p>Convenient</p>
          <p>
            どこにでもある、誰でも使ったことがある、普段は存在を意識しないけどないと困るツールたち。日常をちょっと楽しくしてくれます。
            これからも、何気なく使いやすくデザインされた道具を大事に使っていきたいと思うのです。
          </p>
        </div>
        <figure className="img">
          <img src="/img/tool.jpg" alt="" width="1600" height="1260" />
        </figure>
      </div>
    </section>
  )
}

const Page = () => {
  return (
    <Layout>
      <Seo title="文章量（多め）にしたレンダリング結果" />
      <div css={[design, flex01]}>
        <Parts />
      </div>
      <div css={[design, flex02]}>
        <Parts />
      </div>
      <div css={[design, flex03]}>
        <Parts />
      </div>
      <div css={[design, grid01]}>
        <Parts />
      </div>
      <div css={[design, grid02]}>
        <Parts />
      </div>
      <div css={[design, grid03]}>
        <Parts />
      </div>
    </Layout>
  )
}

const flex01 = css`
  .imgtext-container {
    display: flex;
    flex-direction: column;
    gap: 45px 80px;
  }

  @media (min-width: 768px) {
    .imgtext-container {
      flex-direction: row;
      align-items: center;
    }
  }
`

const flex02 = css`
  .imgtext-container {
    display: flex;
    flex-direction: column;
    gap: clamp(45px, 6vw, 80px);
  }

  @media (min-width: 768px) {
    .imgtext-container {
      flex-direction: row;
      align-items: center;
    }

    .imgtext-container > .text {
      flex: 1;
    }

    .imgtext-container > .img {
      flex: 2;
    }
  }
`

const flex03 = css`
  .imgtext-container {
    display: flex;
    flex-direction: column;
    gap: clamp(45px, 6vw, 80px);
  }

  @media (min-width: 768px) {
    .imgtext-container {
      flex-direction: row;
      align-items: center;
    }

    .imgtext-container > .text {
      flex: 1;
      min-width: 17em;
    }

    .imgtext-container > .img {
      flex: 2;
    }
  }
`

const grid01 = css`
  .imgtext-container {
    display: grid;
    gap: 45px 80px;
  }

  @media (min-width: 768px) {
    .imgtext-container {
      grid-template-columns: auto auto;
      align-items: center;
    }
  }
`

const grid02 = css`
  .imgtext-container {
    display: grid;
    gap: clamp(45px, 6vw, 80px);
  }

  @media (min-width: 768px) {
    .imgtext-container {
      grid-template-columns: 1fr 2fr;
      align-items: center;
    }
  }
`

const grid03 = css`
  .imgtext-container {
    display: grid;
    gap: clamp(45px, 6vw, 80px);
  }

  @media (min-width: 768px) {
    .imgtext-container {
      grid-template-columns: 1fr 2fr;
      align-items: center;
    }

    .imgtext-container > .text {
      min-width: 17em;
    }
  }
`

const design = css`
  .imgtext {
    padding: clamp(90px, 9vw, 120px) 0;
    background-color: #ffffff;
  }

  h2 {
    font-size: clamp(30px, 3vw, 40px);
    min-height: 0vw;
    font-weight: 400;
  }

  h2::after {
    display: block;
    content: "";
    width: 160px;
    height: 0px;
    border-top: solid 1px #b72661;
    margin-top: 0.6em;
  }

  h2 + p {
    margin-top: 1em;
    margin-bottom: 2em;
    color: #707070;
    font-family: "Montserrat", sans-serif;
    font-size: 18px;
  }
`

export default Page
